import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { ScrollService } from 'src/app/shared/services/scroll.service';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatList, MatListItem } from '@angular/material/list';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';


@Component({
    selector: 'app-footer-menu',
    templateUrl: './footer-menu.component.html',
    styleUrls: ['./footer-menu.component.scss'],
    standalone: true,
    imports: [RouterLink, FaIconComponent, MatList, MatListItem, TranslateModule]
})
export class FooterMenuComponent{
  faLinkedin = faLinkedin;
  constructor(protected router: Router,
    public scrollService: ScrollService) { }
  @Input() containsFooter: boolean;

  scrollHome(scrollTo: string) {
    this.router.navigate(['/site']).then( () => {
        this.scrollService.scroll.next(scrollTo);
    }
    )
  }


  scrollSolutions(scrollTo: string) {
    this.router.navigate(['/site/solucoes']).then( () => {
    this.scrollService.scroll.next(scrollTo);
    })
  }
}
